export const home = {
  "Você tem assinaturas pendentes.": "Você tem assinaturas pendentes.",
  "Para regulariza-las baixe o aplicativo da MarQ. e faça as solicitações.": "Para regulariza-las baixe o aplicativo da MarQ. e faça as solicitações.",
  "Baixe agora.": "Baixe agora.",
  "Você tem uma admissão online em aberto.": "Você tem uma admissão online em aberto.",
  "Para regulariza-la baixe o aplicativo da MarQ. e faça as solicitações.": "Para regulariza-la baixe o aplicativo da MarQ. e faça as solicitações.",
  "Que tal relembrar ": "Que tal relembrar ",
  "os seus momentos": "os seus momentos",
  "com a gente?": "com a gente?",
  "Relembrar o meu ano": "Relembrar o meu ano",
  "Retro": "Retro",
  "Você está em regime de sobreaviso": "Você está em regime de sobreaviso",
  "Hora de início do regime:": "Hora de início do regime:",
  "Hora de término do regime:": "Hora de término do regime:",
  "Hora:": "Hora:",
  "Último ponto registrado:": "Último ponto registrado:",
  "Nenhum ponto registrado": "Nenhum ponto registrado",
  "Horas faltantes": "Horas faltantes",
  "Jornada Completa": "Jornada Completa",
  "Ver detalhes de hoje": "Ver detalhes de hoje",
  "Ponto em processamento": "Ponto em processamento",
  "Seu ponto das": "Seu ponto das",
  "já foi registrado!": "já foi registrado!",
  "Atualize a página para visualizar o ponto.": "Atualize a página para visualizar o ponto.",
  "Atualizar página": "Atualizar página",
  "Pausa iniciada em:": "Pausa iniciada em:",
  "Você está em": "Você está em",
  "pausa": "pausa",
  "Voltar da pausa": "Voltar da pausa",
  "Saldo de horas": "Saldo de horas",
  "Saldo acumulado desde": "Saldo acumulado desde",
  "Não lido": "Não lido",
  "Detalhes": "Detalhes",
  "Reuniões 1:1": "Reuniões 1:1",
  "Confira suas reuniões 1:1 agendadas, após o término, não se esqueça de avaliá-las.": "Confira suas reuniões 1:1 agendadas, após o término, não se esqueça de avaliá-las.",
  "Novo lembrete": "Novo lembrete",
  "Você tem um novo lembrete, clique aqui para ver os detalhes.": "Você tem um novo lembrete, clique aqui para ver os detalhes.",
  "Tarefas pendentes": "Tarefas pendentes",
  "Você tem tarefas pendentes em seu nome, clique aqui para ver os detalhes": "Você tem tarefas pendentes em seu nome, clique aqui para ver os detalhes",
  "Últimos 10 dias": "Últimos 10 dias",
  "Ver histórico": "Ver histórico",
  "Data": "Data",
  "Trabalhado": "Trabalhado",
  "Saldo": "Saldo",
  "Status": "Status",
  "Nenhum registro": "Nenhum registro",
  "Comunicados": "Comunicados",
  "Ver todos": "Ver todos",
  "Nenhum comunicado": "Nenhum comunicado",
  "Novo comunicado": "Novo comunicado",
  "Assinatura": "Assinatura",
  "Você tem uma assinatura pendente, abra para regularizar a solicitação.": "Você tem uma assinatura pendente, abra para regularizar a solicitação.",
  "Novo chat": "Novo chat",
  "Você tem uma nova mensagem no chat clique para ver a mensagem": "Você tem uma nova mensagem no chat clique para ver a mensagem",
  "Admissão online": "Admissão online",
  "Preencha aqui as informações necessárias de admissão": "Preencha aqui as informações necessárias de admissão",
  "Chegou um feedback": "Chegou um feedback",
  "Você tem um novo Feedback, veja o que estão sentindo do seu trabalho": "Você tem um novo Feedback, veja o que estão sentindo do seu trabalho",
  "Envio de documento": "Envio de documento",
  "Você tem um ou mais documentos pendentes para serem enviados": "Você tem um ou mais documentos pendentes para serem enviados",
  "Espelho ponto": "Espelho ponto",
  "Você tem um ou mais espelhos de ponto para serem assinados": "Você tem um ou mais espelhos de ponto para serem assinados",
  "Ocorrências": "Ocorrências",
  "Solicite os ajustes necessários para resolver as suas ocorrências": "Solicite os ajustes necessários para resolver as suas ocorrências",
  "GET_MY_TEAMS": "GET_MY_TEAMS",
  "realodPage": "realodPage",
  "Férias": "Férias",
  "Afastamento": "Afastamento",
  "Solicitado": "Solicitado",
  "Aprovado": "Aprovado",
  "Recusado": "Recusado",
  "Concluído": "Concluído",
  "Ocorrência": "Ocorrência",
  "Falta": "Falta",
  "Dia atual": "Dia atual",
  "Fechar": "Fechar",
  "Admissão": "Admissão",
  "Este é o horário oficial central e pode estar diferente do horário do seu computador.": "Este é o horário oficial central e pode estar diferente do horário do seu computador.",
  "dica de ferramenta": "dica de ferramenta",
  "Em caso de dúvidas sobre seu saldo, entre em contato com seu RH ou Gestor.": "Em caso de dúvidas sobre seu saldo, entre em contato com seu RH ou Gestor.",
  "Em caso de dúvidas sobre seu saldo, entre em contato com seu RH ou Gestor. Última atualização do histórico de dias foi feita no dia": "Em caso de dúvidas sobre seu saldo, entre em contato com seu RH ou Gestor. Última atualização do histórico de dias foi feita no dia",
  "Última atualização dos comunicados foi feita no dia": "Última atualização dos comunicados foi feita no dia"
};



// WEBPACK FOOTER //
// ./src/resources/ptBR/home.js